<h2 mat-dialog-title>{{data.Title}}</h2>
<div *ngIf="data.message">{{data.message}}</div>
<mat-dialog-content>
    <div *ngIf="data.NumberOfCopies" style="padding-top:1.2em;">
        <span>{{data.NumberOfCopies.Label}}&nbsp;</span>
        <mat-slider min="1" [max]="data.NumberOfCopies?.Max" thumbLabel="true" [(ngModel)]="printQty"></mat-slider>
    </div>

    <form>
        <mat-form-field appearance="fill">
            <mat-label>Scan Printer Tag</mat-label>
            <input scanInput="PTR" (scanned)="selectPrinterScan()" type="text" name="printerSelector" #printerSelector
                matInput [matAutocomplete]="printerSelectAutocomplete" [(ngModel)]="printerID">
            <mat-autocomplete #printerSelectAutocomplete="matAutocomplete">
                <mat-option *ngFor="let printer of settings.WarehousePrinters" [value]="printer.id">{{printer.id}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" mat-raised-button color="accent" (click)="cancel()">Cancel</button>
    <button type="button" mat-raised-button color="primary"
        (click)="selectPrinter()">{{data.ConfirmButtonText}}</button>
</mat-dialog-actions>